import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../header';
import Footer from '../../footer';
import { HiOutlineMail, HiOutlineLockClosed, HiArrowRight } from "react-icons/hi";

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    
    const navigate = useNavigate();
    const location = useLocation();

    // Check where the user came from, default to home if none
    const from = location.state?.from?.pathname || "/";

    const handleLogin = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        // Simulate a network request
        setTimeout(() => {
            localStorage.setItem('isLoggedIn', 'true');
            localStorage.setItem('userEmail', email);
            setIsLoading(false);
            // Navigate back to where they came from
            navigate(from, { replace: true });
        }, 1000);
    };

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col font-sans">
            <Header />

            <main className="flex-1 flex items-center justify-center pt-[140px] sm:pt-[170px] pb-20 px-6 relative overflow-hidden">
                {/* Background Decor */}
                <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#73C8BD] opacity-20 blur-[120px] rounded-full pointer-events-none" />
                <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-amber-200 opacity-20 blur-[100px] rounded-full pointer-events-none" />
                
                <div className="w-full max-w-md relative z-10 animate-fade-in">
                    <div className="bg-white rounded-[32px] p-8 sm:p-10 shadow-2xl border border-slate-100">
                        <div className="text-center mb-8">
                            <h1 className="text-3xl font-extrabold text-slate-900 mb-2">Welcome Back</h1>
                            <p className="text-slate-500 text-sm">Please log in to continue your order.</p>
                        </div>

                        <form onSubmit={handleLogin} className="flex flex-col gap-5">
                            <div>
                                <label className="block text-sm font-bold text-slate-700 mb-2">Email Address</label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                        <HiOutlineMail className="text-slate-400 text-lg" />
                                    </div>
                                    <input 
                                        type="email" 
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="you@example.com"
                                        className="w-full bg-slate-50 border border-slate-200 rounded-xl pl-11 pr-4 py-3.5 text-slate-900 font-medium placeholder:font-normal focus:outline-none focus:ring-2 focus:ring-[#73C8BD] focus:border-transparent transition-all"
                                    />
                                </div>
                            </div>
                            
                            <div>
                                <label className="block text-sm font-bold text-slate-700 mb-2">Password</label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                        <HiOutlineLockClosed className="text-slate-400 text-lg" />
                                    </div>
                                    <input 
                                        type="password" 
                                        required
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="••••••••"
                                        className="w-full bg-slate-50 border border-slate-200 rounded-xl pl-11 pr-4 py-3.5 text-slate-900 font-medium placeholder:font-normal focus:outline-none focus:ring-2 focus:ring-[#73C8BD] focus:border-transparent transition-all"
                                    />
                                </div>
                                <div className="flex justify-end mt-2">
                                    <button 
                                        type="button" 
                                        onClick={() => alert("Please contact support at contact@rainbowtrucks.com to reset your password.")}
                                        className="text-xs font-bold text-[#73C8BD] hover:text-emerald-500 transition-colors"
                                    >
                                        Forgot password?
                                    </button>
                                </div>
                            </div>

                            <button 
                                type="submit"
                                disabled={isLoading}
                                className={`w-full bg-[#181F38] text-white font-bold py-4 rounded-xl hover:bg-slate-800 transition-all shadow-lg flex items-center justify-center gap-2 mt-4 ${isLoading ? 'opacity-80 cursor-wait' : ''}`}
                            >
                                {isLoading ? (
                                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                ) : (
                                    <>
                                        <span>Sign In</span>
                                        <HiArrowRight />
                                    </>
                                )}
                            </button>
                        </form>
                        
                        <div className="mt-8 text-center text-sm font-medium text-slate-500">
                            Don't have an account?{' '}
                            <button 
                                type="button" 
                                onClick={() => alert("New user registrations are open! You can log in directly with any email to test.")}
                                className="text-[#73C8BD] font-bold hover:underline"
                            >
                                Sign up
                            </button>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
